import React from 'react';
import { InputContainerStyle } from './Component.style';
import clsx from 'clsx';
import OutlinedInput from '@mui/material/OutlinedInput';
import { FormControl } from '@mui/material';

import { ReactComponent as Exclamation } from 'assert/images/Common/exclamation.svg';

function Input({
  label,
  errMsg,
  name,
  value,
  onChange,
  placeholder,
  required,
  disabled,
  onBlur,
  type,
  showPassword,
  changeIcon,
  eyeIcon,
  rightLabel,
  onRightLabel,
  className,
  maxRows,
  maxLimit,
  ...props
}) {
  return (
    <InputContainerStyle className='InputContainerStyle'>
      <FormControl
        required={required}
        className={clsx('inputContainer', className)}
      >
        <div className="labelContainer">
          {label && (
            <div className="lebelView">
              <label>
                {label} {required && <span className="requiredSymbol">*</span>}
              </label>
            </div>
          )}
          {rightLabel && (
            <div className="rightLabel">
              <div onClick={onRightLabel}>
                <a>{rightLabel}</a>
              </div>
            </div>
          )}
        </div>
        <OutlinedInput
          type={type || 'text'}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          maxRows={maxRows || 2}
          inputProps={{ maxLength: maxLimit || 100 }}
          {...props}
        />
        {errMsg && (
          <span className="errMsg">
            <Exclamation />
            {errMsg}
          </span>
        )}
      </FormControl>
    </InputContainerStyle>
  );
}

export default Input;
